import {
    MDBCard,
    MDBCardBody,
    MDBRow,
    MDBCol,
    MDBFooter,
    MDBBtn,
    MDBPageItem ,MDBPagination , MDBPageNav ,

} from 'mdbreact';
// import TextField from '@material-ui/core/TextField';
import React from 'react';
// import { VisaeroJumbotron } from '../Common/VisaeroJumbotron';
import { Redirect } from 'react-router-dom';
import axios from '../../authAxios'
// import { UndoRounded } from '@material-ui/icons';
// import Swal from "sweetalert2"

const brand_color = localStorage.getItem('brand_color')
export class Notification extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            brand_color : "",
            notification_array: [],
            isCancel: false,
            toTrack: false,
            showPaymentConfirmModel: false,
            reciept_number: '',
            booking_info_for_payment: '',
            isRecieptError: false,
            recieptErrormsg: '',
            isAdminVerify: false,
            isNotification: false,
            paginatedItems : [],
            prePage : "",
            nextPage : "",
            pageNo : 1,
            totalPages : ""
        }
        this.handle_actions = this.handle_actions.bind(this)
        this.previousPage= this.previousPage.bind(this)
        this.nextPage = this.nextPage.bind(this)
    }

    componentDidMount() {
        this.setState({brand_color : localStorage.getItem("brand_color")})

        this.api_getNotifications()
    }

    pagination(items,currentPage , itemsPerPage){

        let current_page = currentPage || 1 ;
        let items_perPage = itemsPerPage || 20 ;
        let offset = (current_page - 1) * items_perPage

        let paginated_items = items.slice(offset).slice(0,items_perPage)
        let total_pages = Math.ceil(items.length / items_perPage)
       

        this.setState({paginatedItems : paginated_items 
            , nextPage :( (total_pages > current_page) ? current_page + 1 : total_pages ) 
            , prePage :( (current_page - 1) ? current_page - 1  : 1 ) ,
            totalPages : total_pages
        })


        return {
            page : current_page ,
            items_page : items_perPage,
            pre_page : (current_page - 1) ? current_page -1  : null ,
            next_page : (total_pages > current_page) ? current_page + 1 : null ,
            total : items.length ,
            totalPages: total_pages,
            data: paginated_items
        }


    }


    previousPage(){
        this.pagination((this.state.notification_array),(this.state.prePage),20)
        this.setState({pageNo : this.state.prePage})
    }

    nextPage(){
        this.pagination((this.state.notification_array),(this.state.nextPage),20)
        this.setState({pageNo: this.state.nextPage})
    }


    handle_cancel_btn_click() {
        this.setState({ isCancel: true })
    }
    convert_Epoch_to_Str(epochDate) {
        // console.log(epochDate)
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];
        var dt = new Date(epochDate)//(1610693910794.0)
        // console.log(dt)
        var dateStr = dt.getDate() + "-" + monthNames[(dt.getMonth())] + "-" + dt.getFullYear() + " " + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        // console.log(dateStr)
        return dateStr
    }
    handle_actions(notificationObj) {
        console.log(notificationObj)
        var dataArr = notificationObj.data

        if (dataArr !== null || dataArr !== undefined) {
            var status = notificationObj.data.status
            var application_id = notificationObj.data.application_id
            // console.log("========")
            // console.log(status)
            // console.log(application_id)
            this.api_check_action_status(application_id, status, notificationObj)
        }

    }
    handle_notification_redirection(notificationObj, applicationObj) {
        var actionArr = notificationObj.action
        var controller = ''
        if (actionArr.length > 0) {
            controller = actionArr[0].controller
        }
        console.log("controller====")
        console.log(controller)
        console.log(applicationObj)
        switch (controller) {
            case 'TrackApplication':
                this.setState({toTrack:true})
                // this.setState({
                //     booking_info_for_payment: applicationObj,
                //     showPaymentConfirmModel: !this.state.showPaymentConfirmModel
                // })
                break;
            case 'ReviewApplication':
                // pending_admin_verification
                this.redirect_to_Verify(applicationObj)
                break;

            default:
                break;
        }
    }
    redirect_to_Verify = (bookingInfo) => {
        localStorage.setItem("application_id", bookingInfo._id)
        localStorage.setItem('travelling_to_identity', bookingInfo.travelling_to_identity)
        // localStorage.setItem("user_viewer", 'admin')
        this.setState({ isAdminVerify: true })
    }
     
    // API Integrations
    api_getNotifications() {
        //https://visaero-stage-backend.visaero.com/visa/getUserAppNotifications?user_id=603cd189a90670093f89a64c
        axios.get('visa/getUserAppNotifications', {
            params: {
                // host: localStorage.getItem('host'),
                user_id: localStorage.getItem('user_id') 
            },
        })
            .then((res) => {
                // console.log(res.data.dataobj.length)
                if (res.data.data === "success") {
                    if (res.data.dataobj.length > 0) {
                        this.setState({
                            notification_array: res.data.dataobj,
                            isNotification: true
                        })
                        this.pagination(res.data.dataobj,this.state.pageNo,20)
                    } else {
                        this.setState({
                            notification_array: [],
                            isNotification: false
                        })
                    }

                } else {

                }
            })
            .catch((err) => {
                //console.log(err)
            })
    }
    api_check_action_status(application_id, status, notificationObj) {
        axios
            .post('/visa-admin/verifyApplicationStatus', {
                "application_id": application_id,
                "host": localStorage.getItem('host'),
                "status": status
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                console.log(res);
                console.log("-----------")
                if (res.data.data === "success") {
                    this.handle_notification_redirection(notificationObj, res.data.dataobj)
                } else {
                    // Swal.fire({ icon: 'error',
                    // text:  res.data.dataobj ,})
                    alert(res.data.dataobj)
                }


            }).
            catch(err => {
                console.log(err);
            })
    }
    // UI PART will start here
    //*Special Note*: asdsd
    showNotificationCard(notificationObj) {
        var datestr = notificationObj.issued_on
        datestr = this.convert_Epoch_to_Str(datestr)
        return <>
            
                    <div className="card mb-3 ">
                        <div className="card-body">
                            <h6 className="font-weight-bold">{notificationObj.title}</h6>
                            <p className="description">{datestr}</p>
                            <p>{notificationObj.message}</p>
                            <p className="mb-0">{
                            notificationObj.action.map((actionObj) => {
                                // return this.showActionsCard(actionObj)
                                return <>
                                    
                                        <MDBBtn color="none" className="m-0"  style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(6px + .5rem)', textTransform: 'none' }} onClick={() => this.handle_actions(notificationObj)}>{actionObj.display}</MDBBtn>
                                    
                                </>
                            })
                        }</p>
                        </div>
                    </div>  
        </>
    }
    showEmptyNotification() {
        return <>
            <MDBRow>
                <MDBCol    >
                    <label style={{textColor:'black'}}  > You don't have any notifications yet.</label>
                </MDBCol>
            </MDBRow>
        </>
    }

    render() {
        if (this.state.isCancel) {
            return <Redirect to="/dashboard" />
        }
        if (this.state.toTrack) {
            return <Redirect to="/track-application" />
        }
        if (this.state.isAdminVerify) {
            return <Redirect to="/new-visa/review" />
        }
        return (
            <>
                <h4><b>Notifications</b></h4>
                {/* <VisaeroJumbotron jumbotrontext="Notifications" /> */}
                {/* style={{  border: '1px solid rgba(0, 0, 0, 0.05)' }} */}
                <MDBCard >
                    <MDBCardBody> 
                            
                                {this.state.isNotification ?
                                    this.state.paginatedItems.map((notificationObj) => {
                                        return this.showNotificationCard(notificationObj)
                                    })
                                    :
                                    this.showEmptyNotification()
                                }  
                    </MDBCardBody>
                </MDBCard>
                {
                                    this.state.notification_array.length >= 20 &&

                                    <MDBRow id="footerRow" style={{width:"100%"  }}>
                                    <MDBFooter style={{background: "#fff" ,  position: "fixed", bottom: "0px" ,width: "100%" ,   right: "0" , borderTop: "1px solid #ccc" , boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" , zIndex : "-1"}} color="white" className="pb-1 pt-1 text-right">
   
                                   <MDBRow>
                                       <MDBCol>
                                           <MDBPagination style={{zIndex:"0"}} className=" float-right  bottom-0 right-0">
                                               <MDBPageItem>
                                                   <MDBPageNav aria-label="Previous">
                                                       <span aria-hidden="true" style={{fontWeight : (this.state.pageNo === 1 ? "" : "bold")  , cursor : (this.state.pageNo === 1 ? "auto" : "pointer")} } onClick={this.previousPage}>Previous</span>
                                                   </MDBPageNav>
                                               </MDBPageItem>
                                               <MDBPageItem>
                                                   <MDBPageNav  >
                                                      <span style={{backgroundColor : "#2e3192" ,}} className="p-2 text-white pl-3 pr-3 ">{this.state.pageNo === "" ? 1 : this.state.pageNo }</span>
                                                   
                                               </MDBPageNav>
                                               </MDBPageItem>
                                              
                                               <MDBPageItem>
                                                   <MDBPageNav aria-label="Previous">
                                                       <span aria-hidden="true" onClick={this.nextPage}  style={{fontWeight : (this.state.pageNo === this.state.totalPages ? "" : "bold")  , cursor : (this.state.pageNo === this.state.totalPages ? "auto" : "pointer")} }>Next</span>
                                                   </MDBPageNav>
                                               </MDBPageItem>
                                           </MDBPagination>
                                       </MDBCol>
                                   </MDBRow>
                                   </MDBFooter>   
                                    </MDBRow> 
                        }
                

            </>
        );
    }
};

export default Notification;